import 'intersection-observer'; // IE11 IntersectionObserver polyfill
import picturefill from 'picturefill';
import smoothscroll from 'smoothscroll-polyfill';


picturefill(); // IE11 picture polyfill
smoothscroll.polyfill(); // IE11 smooth scroll polyfill
